import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";
import { faHome } from "@fortawesome/free-solid-svg-icons";
import Flex from "../../components/common/Flex";
import Logo from "../../components/common/Logo";
import Section from "../../components/common/Section";

const Error404 = () => {
	return (
		<Section className="py-0">
			<Row className="flex-center min-vh-100 py-6">
				<Col sm={10} md={8} lg={6} xl={5} className="col-xxl-4 ">
					<Flex justifyContent="center" alignItems="center" className="mb-4">
						<Logo width={200} />
					</Flex>
					<Card className="text-center">
						<Card.Body className="p-5">
							<div className="display-1 text-300 fs-error">404</div>
							<p className="lead mt-4 text-800 font-sans-serif fw-semi-bold">
								The page you're looking for is not found.
							</p>
							<hr />
							<p>
								Make sure the address is correct and that the page hasn't moved.
								If you think this is a mistake,
								<a href="mailto:info@exmaple.com" className="ms-1">
									contact us
								</a>
								.
							</p>
							<Link className="btn btn-primary btn-sm mt-3" to="/users">
								<FontAwesomeIcon icon={faHome} className="me-2" />
								Take me home
							</Link>
						</Card.Body>
					</Card>
				</Col>
			</Row>
		</Section>
	);
};

export default Error404;
